import React from "react"

import { styled } from "@mui/styles"

import { ExcelIcon } from "./components/ExcelIcon"
import { JpgIcon } from "./components/JpgIcon"
import { PdfIcon } from "./components/PdfIcon"
import { PowerPointIcon } from "./components/PowerPointIcon"
import { WordIcon } from "./components/WordIcon"
import { SupportedFileType } from "./constants/supportedFileType"
import { MuiIcon } from "../MuiIcon"

interface IProps {
  fileType: SupportedFileType | string
}

export const FileIcon = ({ fileType }: IProps) => {
  if (fileType === SupportedFileType.docx) {
    return <WordIcon />
  }

  if (fileType === SupportedFileType.pptx) {
    return <PowerPointIcon />
  }

  if (fileType === SupportedFileType.xlsx) {
    return <ExcelIcon />
  }

  if (fileType === SupportedFileType.pdf) {
    return <PdfIcon />
  }

  if (fileType === SupportedFileType.jpg) {
    return <JpgIcon />
  }

  if (fileType === SupportedFileType.png) {
    return <MuiIcon.PanoramaOutlined sx={{ fontSize: "18px" }} />
  }

  if (fileType === SupportedFileType.webp) {
    return <MuiIcon.PanoramaOutlined sx={{ fontSize: "18px" }} />
  }

  if (fileType === SupportedFileType.gif) {
    return <MuiIcon.PanoramaOutlined sx={{ fontSize: "18px" }} />
  }

  if (fileType === SupportedFileType.webm) {
    return <MuiIcon.MicNoneOutlined sx={{ fontSize: "18px" }} />
  }

  if (fileType === SupportedFileType.mp4) {
    return <MuiIcon.VideocamOutlined sx={{ fontSize: "18px" }} />
  }

  if (fileType === SupportedFileType.zip) {
    return <MuiIcon.FolderZip sx={{ fontSize: "18px" }} />
  }

  return <Empty />
}

const Empty = styled("div")({
  width: "18px",
  height: "18px"
})
